import { Category, ICategoryArgs } from "../category/category.model";

export interface IJobStatusArgs extends ICategoryArgs {
    closed?: boolean;
    timeout?: number;
    timeoutStatus?: string;
}

const defaults = {
    closed: false,
    timeout: undefined,
    timeoutStatus: ""
} as IJobStatusArgs;

export class JobStatus extends Category {
    closed: boolean;
    timeout: number;
    timeoutStatus: string;

    constructor(data?: IJobStatusArgs) {
        super({...defaults, ...data} as any);
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/job-status/job-status.model.ts